import { render, staticRenderFns } from "./index.vue?vue&type=template&id=590398e6&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('590398e6')) {
      api.createRecord('590398e6', component.options)
    } else {
      api.reload('590398e6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=590398e6&", function () {
      api.rerender('590398e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AnimateNumber/index.vue"
export default component.exports